export const VERIFY_REQUEST = 'me/VERIFY_REQUEST';
export const VERIFY_SUCCESS = 'me/VERIFY_SUCCESS';
export const VERIFY_FAILURE = 'me/VERIFY_FAILURE';

export const RESET_PASSWORD_REQUEST = 'me/RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'me/RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'me/RESET_PASSWORD_FAILURE';

export const RECOVER_PASSWORD_REQUEST = 'me/RECOVER_PASSWORD_REQUEST';
export const RECOVER_PASSWORD_SUCCESS = 'me/RECOVER_PASSWORD_SUCCESS';
export const RECOVER_PASSWORD_FAILURE = 'me/RECOVER_PASSWORD_FAILURE';

export const REFRESH_WALLET_REQUEST = 'me/REFRESH_WALLET_REQUEST';
export const REFRESH_WALLET_SUCCESS = 'me/REFRESH_WALLET_SUCCESS';
export const REFRESH_WALLET_FAILURE = 'me/REFRESH_WALLET_FAILURE';

export const USER_PREMIUM_PLANS_REQUEST = 'me/USER_PREMIUM_PLANS_REQUEST';
export const USER_PREMIUM_PLANS_SUCCESS = 'me/USER_PREMIUM_PLANS_SUCCESS';
export const USER_PREMIUM_PLANS_FAILURE = 'me/USER_PREMIUM_PLANS_FAILURE';
